import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const PositiveFill = ({
  height = 16,
  width = 16,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M8 2C6.81331 2 5.65328 2.35189 4.66658 3.01118C3.67989 3.67047 2.91085 4.60754 2.45673 5.7039C2.0026 6.80026 1.88378 8.00666 2.11529 9.17054C2.3468 10.3344 2.91825 11.4035 3.75736 12.2426C4.59648 13.0818 5.66558 13.6532 6.82946 13.8847C7.99335 14.1162 9.19975 13.9974 10.2961 13.5433C11.3925 13.0892 12.3295 12.3201 12.9888 11.3334C13.6481 10.3467 14 9.18669 14 8C13.9982 6.40926 13.3655 4.88419 12.2406 3.75936C11.1158 2.63454 9.59074 2.00181 8 2V2ZM11.0857 7.05714L7.67772 10.4634C7.59811 10.5431 7.50358 10.6063 7.39952 10.6495C7.29547 10.6926 7.18393 10.7148 7.07129 10.7148C6.95865 10.7148 6.84711 10.6926 6.74305 10.6495C6.639 10.6063 6.54447 10.5431 6.46486 10.4634L4.91429 8.91543C4.75357 8.75425 4.66346 8.53583 4.66378 8.30822C4.6641 8.0806 4.75483 7.86244 4.916 7.70171C5.07718 7.54099 5.2956 7.45088 5.52321 7.4512C5.75083 7.45152 5.969 7.54225 6.12972 7.70343L7.07257 8.64629L9.87029 5.846C10.0309 5.68482 10.249 5.59405 10.4765 5.59365C10.704 5.59325 10.9224 5.68325 11.0836 5.84386C11.2448 6.00446 11.3355 6.22252 11.3359 6.45006C11.3363 6.67759 11.2463 6.89597 11.0857 7.05714Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
